import { fmt } from '@/i18n';
import { getEmailSuggestion } from '@/lib/emailSuggestion';

/**
 * Progressive enhancement for the "find my registration" lookup form: an on-blur
 * typo suggestion ("Did you mean gmail.com?") on the email field. The page works
 * without JS; this only adds the suggestion affordance. Shares the suggestion
 * core (@/lib/emailSuggestion) with the React registration form.
 */
const input = document.getElementById('email') as HTMLInputElement | null;
const slot = document.getElementById('email-suggestion');

if (input && slot) {
  const clear = () => {
    slot.replaceChildren();
  };

  input.addEventListener('blur', () => {
    const suggestion = getEmailSuggestion(input.value);
    if (!suggestion) {
      clear();
      return;
    }
    clear();
    const button = document.createElement('button');
    button.type = 'button';
    button.className =
      'mt-2 inline-flex items-center gap-1 text-xs font-medium text-amber-600 hover:text-amber-700 dark:text-amber-500 dark:hover:text-amber-400';
    button.textContent = fmt('Did you mean %(email)s?', { email: suggestion });
    button.setAttribute('aria-label', fmt('Did you mean %(email)s?', { email: suggestion }));
    button.addEventListener('click', () => {
      input.value = suggestion;
      input.focus();
      clear();
    });
    slot.appendChild(button);
  });

  input.addEventListener('input', clear);
}
